import { Box, Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const StyledSwapContainer = styled(Flex)<{ $isChartExpanded: boolean }>`
  flex-shrink: 0;
  height: fit-content;
  padding: 0 16px;

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0 40px;
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    ${({ $isChartExpanded }) => ($isChartExpanded ? 'padding: 0 120px' : 'padding: 0 40px')};
  }
`

export const StyledInputCurrencyWrapper = styled(Box)`
  width: 100%;
  position: relative;
  min-height: 460px;
  /* border: 1px solid #35ed84; */
  border-radius: 30px;

  /* @media (min-width: 968px) {
    margin-left: -45px;
  } */
  /* box-shadow: 0px 0px 40px 0px #6FC7BA; */
`
